// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1fcyI","def":"styles_def__36-Ac","faded":"styles_faded__2mrkB"};